
export function cacheToMetadata (metadataListSymbol, target, propertyName) {
  // Maintain a Set of decorated properties
  if (!Reflect.hasMetadata(metadataListSymbol, target)) {
    Reflect.defineMetadata(metadataListSymbol, new Set([propertyName]), target)
  }
  const metaSet = Reflect.getMetadata(metadataListSymbol, target)
  metaSet.add(propertyName)
}

// Source: https://github.com/mobxjs/mobx/blob/d46bbe5020bbf4f7379ff08875cbfba9fcfb8dd4/src/utils/decorators.ts#L114
export function quacksLikeADecorator(args: IArguments): boolean {
  return (
    ((args.length === 2 || args.length === 3) && typeof args[1] === 'string') ||
    (args.length === 4 && args[3] === true)
  )
}